import React from "react";
import Alert from "@material-ui/lab/Alert";

/**
 * Reusable component to show Activation Profiles validation alerts
 * @param {Array} alerts - Array of objects with condition and message
 * @param {Object} containerStyle - Optional styles for the container
 * @returns {JSX.Element}
 */
const TableAlerts = ({ alerts, containerStyle = {} }) => {
  const defaultContainerStyle = {
    display: "grid",
    gridGap: "1em",
    padding: "10px",
    ...containerStyle,
  };

  return (
    <div style={defaultContainerStyle}>
      {Array.isArray(alerts) &&
        alerts
          .filter((alert) => alert.condition)
          .map((alert, index) => (
            <Alert
              key={index}
              severity="error"
            >
              {alert.message}
            </Alert>
          ))}
    </div>
  );
};

export default TableAlerts;
